import Login from '../views/Login.vue'
import Arena from '../views/Arena.vue'
import Profile from '../views/Profile.vue'
import EmployeeDashboard from '../views/main/dashboard/Employee.vue'
import AdminDashboard from '../views/main/dashboard/Admin.vue'
import Users from '../views/users/Users.vue'
import PlayingNow from '../views/main/PlayingNow.vue'
import PurchaseWrapper from '../components/PurchaseWrapper.vue'
import GlobalProducts from '../views/shop-v2/global-products/index.vue'
import ArenaProducts from '../views/shop-v2/arena-products/index.vue'
import StockTransactions from '../views/shop-v2/stock-transactions/index.vue'
import SortOrder from '../views/shop-v2/sort-order/index.vue'
import Promotions from '../views/shop-v2/promotions/index.vue'
import Invoices from '../views/shop/Invoices.vue'
import InvoicesV2 from '../views/shop-v2/invoices/index.vue'
import Transactions from '../views/shop/Transactions.vue'
import TransactionsV2 from '../views/shop-v2/invoices/transactions/index.vue'
import Articles from '../views/social/Articles.vue'
import Events from '../views/social/Events.vue'
import MobileNotifications from '../views/social/MobileNotifications.vue'
import ShopSettings from '../views/shop-v2/settings/index.vue'
import Finance from '../views/data/Finance.vue'
import Sessions from '../views/main/Sessions.vue'
import Games from '../views/configuration/Games.vue'
import ArenaGames from '../views/configuration/ArenaGames.vue'
import Apps from '../views/configuration/Apps.vue'
import ArenaApps from '../views/configuration/ArenaApps.vue'
import MaxBonuses from '../views/configuration/MaxBonuses.vue'
import SharedAccounts from '../views/shared-accounts/index.vue'
import SharedAccountsStats from '../views/shared-accounts/stats/index.vue'
import CoinHistory from '../views/users/CoinHistory.vue'
import Arenas from '../views/setup/Arenas.vue'
import TaxJurisdictions from '../views/setup/tax-jurisdictions/index.vue'
import NotFound from '../views/statuses/404.vue'
import Forbidden from '../views/statuses/403.vue'

import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'
import store from '../store'
import { arenaHasShopV1History } from '../utils/shopV1'

const PRODUCT_ROUTES = [
  {
    path: 'global-products',
    name: 'entities.products.globalProducts',
    component: GlobalProducts,
    meta: {
      title: 'FF | Global Products',
      roles: ['admin', 'manager'],
    },
  },
  {
    path: 'products',
    name: 'navigationDrawer.shopV2.products',
    component: ArenaProducts,
    meta: {
      title: 'FF | Products',
      roles: ['admin', 'employee', 'manager'],
    },
  },
]

const SHOP_V2_ROUTES = [
  {
    path: 'invoices-v1',
    name: 'navigationDrawer.shopV2.invoicesV1',
    component: Invoices,
    meta: {
      title: 'FF | Invoices V1',
      roles: ['admin', 'employee', 'manager'],
      shopV1History: true,
    },
  },
  {
    path: 'tax-jurisdictions',
    name: 'navigationDrawer.setup.taxJurisdictions',
    component: TaxJurisdictions,
    meta: {
      title: 'FF | Tax Jurisdictions',
      roles: ['admin', 'employee', 'manager'],
    },
  },
  {
    path: 'shop-settings',
    name: 'navigationDrawer.shopV2.settings',
    component: ShopSettings,
    meta: {
      title: 'FF | Shop Settings',
      roles: ['admin', 'employee', 'manager'],
    },
  },
  {
    path: 'stock-transactions',
    name: 'navigationDrawer.shopV2.stockTransactions',
    component: StockTransactions,
    meta: {
      title: 'FF | Stock Transactions',
      roles: ['admin', 'employee', 'manager'],
    },
  },
  {
    path: 'promotions',
    name: 'navigationDrawer.shopV2.promotions',
    component: Promotions,
    meta: {
      title: 'FF | Promotions',
      roles: ['admin', 'employee', 'manager'],
      restrictedCountries: ['ba'],
    },
  },
  {
    path: 'sort-order',
    name: 'navigationDrawer.shopV2.sortOrder',
    component: SortOrder,
    meta: {
      title: 'FF | Sort Order',
      roles: ['admin', 'manager'],
    },
  },
  {
    path: 'transactions-v1',
    name: 'navigationDrawer.shopV2.transactionsV1',
    component: Transactions,
    meta: {
      title: 'FF | Transactions V1',
      roles: ['admin', 'employee', 'manager'],
      shopV1History: true,
    },
  },
]

// Purchase route - uses wrapper component that guards against leaving with a non-empty basket
const PURCHASE_ROUTE = {
  path: 'purchase',
  name: 'navigationDrawer.shop.purchase',
  component: PurchaseWrapper,
  meta: {
    title: 'FF | Purchase',
    roles: ['admin', 'employee', 'manager'],
  },
}

Vue.use(VueRouter)

import updateToken from '@/services/update-token'

const routes = [
  {
    path: '/',
    name: 'login.login',
    component: Login,
    meta: {
      title: 'FF | Login',
      auth: false,
    },
  },
  {
    path: '/:arena?',
    name: 'entities.arenas.entity',
    component: Arena,
    meta: {
      title: 'FF | Arena',
      auth: true,
    },
    children: [
      {
        path: 'profile',
        name: 'profile.title',
        component: Profile,
        meta: {
          title: 'FF | Profile',
        },
      },
      {
        path: 'admin-dashboard',
        name: 'navigationDrawer.main.adminDashboard',
        component: AdminDashboard,
        meta: {
          title: 'FF | Admin Dashboard',
          roles: ['admin', 'manager'],
        },
      },
      {
        path: 'employee-dashboard',
        name: 'navigationDrawer.main.employeeDashboard',
        component: EmployeeDashboard,
        meta: {
          title: 'FF | Employee Dashboard',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'playing-now',
        name: 'navigationDrawer.main.playingNow',
        component: PlayingNow,
        meta: {
          title: 'FF | Playing Now',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'sessions',
        name: 'navigationDrawer.main.sessions',
        component: Sessions,
        meta: {
          title: 'FF | Sessions',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'users',
        name: 'navigationDrawer.users.users',
        component: Users,
        meta: {
          title: 'FF | Users',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'coin-history',
        name: 'navigationDrawer.users.coinHistory',
        component: CoinHistory,
        meta: {
          title: 'FF | User Coin History',
          roles: ['admin'],
        },
      },
      PURCHASE_ROUTE,
      ...PRODUCT_ROUTES,
      {
        path: 'invoices',
        name: 'navigationDrawer.shop.invoices',
        component: InvoicesV2,
        meta: {
          title: 'FF | Invoices',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'transactions',
        name: 'entities.invoices.transactions',
        component: TransactionsV2,
        meta: {
          title: 'FF | Transactions',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'articles',
        name: 'navigationDrawer.newsManager.articles',
        component: Articles,
        meta: {
          title: 'FF | Articles',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'events',
        name: 'navigationDrawer.newsManager.events',
        component: Events,
        meta: {
          title: 'FF | Events',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'mobile-notifications',
        name: 'navigationDrawer.newsManager.mobileNotifications',
        component: MobileNotifications,
        meta: {
          title: 'FF | Mobile Notifications',
          roles: ['admin', 'manager'],
        },
      },
      {
        path: 'finance',
        name: 'navigationDrawer.finance',
        component: Finance,
        meta: {
          title: 'FF | Finance',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'global-games',
        name: 'entities.games.globalGames',
        component: Games,
        meta: {
          title: 'FF | Global Games',
          roles: ['admin', 'manager'],
        },
      },
      {
        path: 'games',
        name: 'navigationDrawer.configuration.games',
        component: ArenaGames,
        meta: {
          title: 'FF | Games',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'global-apps',
        name: 'entities.apps.globalApps',
        component: Apps,
        meta: {
          title: 'FF | Global Apps',
          roles: ['admin', 'manager'],
        },
      },
      {
        path: 'apps',
        name: 'navigationDrawer.configuration.apps',
        component: ArenaApps,
        meta: {
          title: 'FF | Apps',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'max-bonuses',
        name: 'entities.maxBonuses.title',
        component: MaxBonuses,
        meta: {
          title: 'FF | Max Bonuses',
          roles: ['admin', 'manager'],
        },
      },
      {
        path: 'shared-accounts',
        name: 'navigationDrawer.configuration.sharedAccounts',
        component: SharedAccounts,
        meta: {
          title: 'FF | Shared Accounts',
          roles: ['admin', 'employee', 'manager'],
        },
      },
      {
        path: 'shared-accounts/stats',
        name: 'navigationDrawer.configuration.sharedAccountsStats',
        component: SharedAccountsStats,
        meta: {
          title: 'FF | Shared Account Statistics',
          roles: ['admin', 'manager'],
        },
      },
      {
        path: 'arenas',
        name: 'navigationDrawer.setup.arenas',
        component: Arenas,
        meta: {
          title: 'FF | Arenas',
          roles: ['admin'],
        },
      },
      ...SHOP_V2_ROUTES,
    ],
  },
  {
    path: '/statuses/403',
    name: '403',
    component: Forbidden,
    meta: {
      title: 'FF | Forbidden',
      auth: false,
    },
  },
  {
    path: '/statuses/404',
    name: '404',
    component: NotFound,
    meta: {
      title: 'FF | Not Found',
      auth: false,
    },
  },
  {
    path: '*',
    redirect: '/statuses/404',
  },
]

function visiting(route: string, location: string) {
  return route === location
}

function tokenSet(token: string) {
  return localStorage.getItem(token) !== null
}

function preferredArena() {
  return localStorage.getItem('preferred_arena')
}

function getUser() {
  const raw = localStorage.getItem('user')
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    try {
      const decoded = atob(raw)
      const user = JSON.parse(decoded)
      localStorage.setItem('user', JSON.stringify(user))
      return user
    } catch {
      return null
    }
  }
}

function isRole(roles: Array<string>) {
  const user = getUser()
  if (!user) {
    return false
  }
  const userRoles = user.roles
  return userRoles.some((r: string) => roles.includes(r))
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach(async (to, _from, next) => {
  if (tokenSet('access_token')) {
    await updateToken()
  }

  document.title = 'FF | ' + i18n.t(`${to.name}`).toString()

  // Check if user has role for requested page
  if (to.meta && to.meta.roles) {
    const user = getUser()
    if (!user) {
      return next('/')
    } else {
      if (!to.meta.roles.some((r: string) => user.roles.indexOf(r) >= 0)) {
        return next(`/statuses/403`)
      }
    }
  }

  // Block routes restricted in the current country
  if (to.meta && Array.isArray(to.meta.restrictedCountries)) {
    const country = store.getters.country
    if (country && to.meta.restrictedCountries.includes(country)) {
      return next('/statuses/403')
    }
  }

  // Block legacy shop-v1 pages in arenas that never ran shop-v1
  if (to.meta && to.meta.shopV1History) {
    if (!arenaHasShopV1History(to.params.arena)) {
      return next('/statuses/403')
    }
  }

  if (!tokenSet('access_token') && to.matched.some((m) => m.meta.auth)) {
    // If no token but route requires auth redirect to login
    next('/')
  } else if (tokenSet('access_token') && visiting(to.path, '/')) {
    // If token set but visiting login page redirect to dashboard with preferred arena
    next(
      `/${preferredArena() ? preferredArena() + '/' : ''}${
        isRole(['admin', 'manager']) ? 'admin' : 'employee'
      }-dashboard`,
    )
  } else {
    next()
  }
})

export default router
